
import React from 'react';
import { Star, StarHalf, StarOff } from 'lucide-react';

interface StarRatingProps {
  rating: number;
  maxRating?: number;
  size?: number;
  className?: string;
}

const StarRating = ({ 
  rating, 
  maxRating = 5, 
  size = 16,
  className = ""
}: StarRatingProps) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  const emptyStars = Math.floor(maxRating - fullStars - (hasHalfStar ? 1 : 0));
  
  return (
    <div className={`flex items-center ${className}`}>
      {/* Full stars */}
      {Array.from({ length: fullStars }).map((_, i) => (
        <Star key={`full-${i}`} className="text-yellow-400 fill-yellow-400" size={size} />
      ))}
      
      {/* Half star */}
      {hasHalfStar && (
        <StarHalf key="half" className="text-yellow-400 fill-yellow-400" size={size} />
      )}
      
      {/* Empty stars */}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <StarOff key={`empty-${i}`} className="text-gray-300" size={size} />
      ))}
    </div>
  );
};

export default StarRating;
